
import { Card } from "react-bootstrap";

import constants from "../lib/constants";
import Image from "./CustomImage";

const CardVendor = (props) => {
  const { company, verified, locations } = props.data

  const hqLocation = locations && locations.length > 0 ? locations[0] : null;
  const city = hqLocation?.location_city;
  const country = hqLocation?.location_country?.label;
  const location = [city, country].filter(Boolean).join(', ') || 'Not available';

  const logoUrl = company.company_logo_url && company.company_logo_url.length > 0
    ? `${constants.LOGO_URL}/${company.company_logo_url[0].name}`
    : null;

  return (
    <Card className="border-0 shadow mb-4 mb-lg-0">
      <Card.Header className="bg-gray-100 py-4 border-0 text-center">
        <div className="avatar avatar-xxl p-2 mb-2">
          <div className="position-relative h-100 overflow-hidden rounded-circle">
            <Image 
              src={logoUrl}
              width={144}
              height={144}
              alt="user picture"
              className="d-block"
              fallback={company.company_name ? company.company_name.charAt(0) : ''}
            />
          </div>
        </div>
        <h3 className="h5">
          {company.company_name}
        </h3>

        <p className="text-muted text-sm mb-0">
          {location}
        </p>
      </Card.Header>
      <Card.Body>
        {verified &&
          <div className="d-flex align-items-center border-bottom pb-3 mb-3">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center bg-secondary-light"
              style={{ width: "40px", height: "40px" }}
            >
              <img
                src="/content/svg/check.svg"
                alt="Is verified"
              />
            </div>
            <span className="ms-2">Verified</span>
          </div>
        }
        <div>
          <h4 className="h6">{company.company_name} provided</h4>
          <ul className="text-gray-600 mb-0">
            <li key="basic-details">
              Basic company details
            </li>
          </ul>
        </div>
      </Card.Body>
    </Card>
  )
}

export default CardVendor
